import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { DropDownOption, ValueChangeEvent } from '@app/core/interfaces/common/form.interface';
import { Fund } from '@app/core/interfaces/model/fund.interface';
import { InstrumentListResponse } from '@app/core/interfaces/model/instrument.interface';
import { InstrumentService } from '@app/core/services/common/instrument.service';
import { debounceTime, distinctUntilChanged, take } from 'rxjs';

@Component({
  selector: 'app-search-instrument',
  templateUrl: './search-instrument.component.html',
  styleUrls: ['./search-instrument.component.scss'],
})
export class SearchInstrumentComponent implements OnInit, OnChanges {
 @Input() value?: string;
  @Input() fundId?: number;
  @Input() fund?: Fund;
  @Input() disabled = false;
  @Input() searchOnly = false;
  @Output() selectOption = new EventEmitter<{value: InstrumentListResponse | 'add-instrument', query?: string}>();


  options: DropDownOption[] = [];
  debounceTimeout: any;
  @Input() searchExpanded = false;
  selectedInstrument: InstrumentListResponse | null = null


  constructor(private instrumentSrv: InstrumentService) {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

      if (changes['value']?.currentValue) {
        this.searchInstrument({value: changes['value'].currentValue, status: 'VALID'});
        this.searchExpanded = false;
      }
  }


  async searchInstrument(queryData: ValueChangeEvent) {

    if (queryData.value && queryData.value.length >= 3 && (!this.selectedInstrument || queryData.value !== this.selectedInstrument.name)) {
      this.options = [];
      this.searchExpanded = false;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.instrumentSrv.search(this.fundId!, queryData.value).pipe(debounceTime(400), distinctUntilChanged()).subscribe({
        next: res => {
          if (res && res.length) {
            this.options = res;
            this.searchExpanded = true;
          } else {
            this.options = [
              { name: 'Create New instrument', value: 'add-instrument', icon: false, iconInfo: 'system-add', data: queryData },
            ];
            this.searchExpanded = true;
          }
        },
        error: err => console.log(err)
      });

    } else {
      this.options = [];
      this.searchExpanded = false;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
    }

  }


optionSelected({ value, option }: { value: InstrumentListResponse | 'add-instrument'; option: DropDownOption }) {

    if (value === 'add-instrument') {
      this.selectOption.emit({value, query: option.data.value as string});
    }else{
      const instrument = value as InstrumentListResponse;
      this.selectedInstrument = instrument;
      this.searchExpanded = false;
      this.selectOption.emit({value: instrument})
    }


  }


}
